module.exports = __webpack_public_path__ + "img/b.6f831720.png";